import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { ASSETS } from "../lib/brand";

const ITEMS = [
  { img: ASSETS.rack, tag: "Look 001", title: "Vermelho editorial", meta: "Vestido · botas verdes" },
  { img: ASSETS.phone, tag: "Look 002", title: "Ouro & jeans", meta: "Camisa acetinada · macacão" },
  { img: ASSETS.hangers, tag: "Look 003", title: "Cabides selecionados", meta: "Curadoria — outono" },
  { img: ASSETS.hero, tag: "Look 004", title: "Estúdio Herida", meta: "Editorial · MMXXVI" },
];

function Card({ item, className, index }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-15% 0px" });

  return (
    <motion.figure
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.9, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className={`relative group ${className}`}
      data-testid={`lookbook-item-${index}`}
    >
      <div className="relative w-full h-full overflow-hidden bg-cream-200">
        <motion.img
          src={item.img}
          alt={item.title}
          initial={{ scale: 1.15 }}
          animate={inView ? { scale: 1 } : {}}
          transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
        />
        <motion.div
          initial={{ scaleY: 1 }}
          animate={inView ? { scaleY: 0 } : {}}
          transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1], delay: 0.05 }}
          style={{ transformOrigin: "top" }}
          className="absolute inset-0 bg-brick-500 z-10"
        />
        {/* Bottom card */}
        <div className="absolute left-3 right-3 bottom-3 flex items-end justify-between font-mono text-[9px] uppercase tracking-[0.3em] text-cream mix-blend-difference z-20">
          <span>{item.tag}</span>
          <span>{item.meta}</span>
        </div>
      </div>
      <figcaption className="mt-3 flex items-baseline justify-between">
        <span className="font-serif italic text-lg sm:text-xl text-ink-800">
          {item.title}
        </span>
        <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink-800/60">
          Editorial
        </span>
      </figcaption>
    </motion.figure>
  );
}

export default function Lookbook() {
  return (
    <section
      id="curadoria"
      data-testid="lookbook-section"
      className="relative bg-cream-100 py-24 sm:py-40 border-t border-ink-800/15"
    >
      <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
        <div className="grid grid-cols-12 gap-6 lg:gap-16 items-end mb-16">
          <div className="col-span-12 lg:col-span-7">
            <div className="flex items-center gap-4 font-mono text-[10px] uppercase tracking-[0.3em] text-ink-800/60 mb-8">
              <span className="w-8 h-px bg-brick-500" />
              <span>Editorial — Vol. I</span>
            </div>
            <h2
              className="font-serif leading-[0.9] tracking-tight text-ink-800"
              style={{ fontSize: "clamp(3rem, 7vw, 7rem)" }}
            >
              O olhar de <br />
              <span className="italic-serif text-brick-500">quem faz.</span>
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-4 lg:col-start-9">
            <p className="font-sans text-base sm:text-lg leading-relaxed text-ink-800/70">
              Um recorte visual do meu universo — bastidores, direção e
              a estética que traduz minha moda circular em imagem.
            </p>
          </div>
        </div>

        {/* Asymmetric grid */}
        <div className="grid grid-cols-12 gap-4 sm:gap-6 auto-rows-[200px] sm:auto-rows-[260px] lg:auto-rows-[300px]">
          <Card item={ITEMS[0]} index={0} className="col-span-12 sm:col-span-7 row-span-2" />
          <Card item={ITEMS[1]} index={1} className="col-span-12 sm:col-span-5 row-span-2 lg:mt-16" />
          <Card item={ITEMS[2]} index={2} className="col-span-6 sm:col-span-4 row-span-2 lg:mt-8" />
          <Card item={ITEMS[3]} index={3} className="col-span-6 sm:col-span-8 row-span-2" />
        </div>
      </div>
    </section>
  );
}
